import {isSessionQuestionAnswered as isSessionQuestionAnsweredModel} from '@cp/model';
import type {SessionQuestion} from '@cp/model';

export default function isSessionQuestionAnswered(question?: SessionQuestion) {
  if (!question) return false;
  return isSessionQuestionAnsweredModel(question as Parameters<typeof isSessionQuestionAnsweredModel>[0]);
}
